/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CountryDetail } from './countryDetail';
import { Format } from './format';
import { OperatorDetail } from './operatorDetail';
import { RouteDetail } from './routeDetail';

export interface RouteService { 
    routeDetail?: RouteDetail;
    countryDetail?: CountryDetail;
    operatorDetail?: OperatorDetail;
    format?: Format;
}